import { Heading, Text } from '@skin-seoul/design-system';
import { forwardRef } from 'react';

interface SectionTitleProps {
  theme: 'light' | 'dark';
  children: React.ReactNode;
}

interface SectionSubTitleProps {
  theme?: 'light' | 'dark';
  children: React.ReactNode;
}

export const CampaignSectionTitle = forwardRef<HTMLHeadingElement, SectionTitleProps>(
  ({ theme, children, ...props }, ref) => (
    <Heading
      as="h2"
      ref={ref}
      color={theme === 'light' ? '#14101B' : '#fff'}
      textStyle="heading.h5"
      fontWeight="medium"
      margin={0}
      {...props}
    >
      {children}
    </Heading>
  ),
);

CampaignSectionTitle.displayName = 'SectionTitle';

export const CampaignSectionSubTitle = forwardRef<HTMLParagraphElement, SectionSubTitleProps>(
  ({ theme = 'light', children, ...props }, ref) => (
    <Text
      as="span"
      textStyle="paragraph.medium"
      color={theme === 'light' ? '#9D9BA1' : '#bbbabe'}
      fontWeight="regular"
      ref={ref}
      {...props}
    >
      {children}
    </Text>
  ),
);

CampaignSectionSubTitle.displayName = 'SectionSubTitle';
